'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { CSSSlider } from '@/ui/layouts/css-slider/CSSSlider.client'
import {
  BLOCK_IMAGE_LINK_CLASSNAME,
  BLOCK_IMAGE_LINK_MODE,
  BLOCK_IMAGE_LINK_PICTURE_CLASSNAME,
  BlockImageLink,
} from '@/ui/links/block-image-link/BlockImageLink.client'
import { CATEGORY_IMAGE_SIZE_ICON } from '@/ui/media/cloudflare-picture-category/CloudflarePictureCategory'
import { CloudflarePicture } from '@/ui/media/cloudflare-picture/CloudflarePicture.client'
import { gql } from '@gql-generated/gql'
import type { CategoriesSlider_CategoriesFragment } from '@gql-generated/graphql'
import { createDisplayOurProductsScreenIntent } from '../../services/universe.intents'
import { toProductListCategoryOrUniversePage } from '../../services/universe.routing'

gql(/* GraphQL */ `
  fragment CategoriesSlider_Categories on Category {
    urlKey
    id
    name
    mainImage {
      ...FullPicture
    }
    isUniverse
  }
`)

type CategoriesSliderProps = {
  categories: CategoriesSlider_CategoriesFragment[]
  source?: 'header' | 'universe'
  className?: string
}

export function CategoriesSlider({
  categories,
  source,
  className,
}: CategoriesSliderProps): React.ReactElement {
  return (
    <CSSSlider gap="md" className={twMerge('mt-3', className)} preventArrowOverlap>
      {categories.map((category) => (
        <BlockImageLink
          key={category.id ?? category.urlKey}
          href={toProductListCategoryOrUniversePage(category.urlKey)}
          trackingData={
            source === 'universe'
              ? {
                  event: 'gaEvent',
                  eventCategory: 'page univers',
                  eventAction: 'clic bloc découvrez également',
                  eventLabel: `bloc découvrez également | ${category.name}`,
                }
              : undefined
          }
          imageComponent={
            <CloudflarePicture
              src={category.mainImage?.set?.[0]?.url}
              alt=""
              width={CATEGORY_IMAGE_SIZE_ICON}
              mode={BLOCK_IMAGE_LINK_MODE}
              className={BLOCK_IMAGE_LINK_CLASSNAME}
              pictureClassName={BLOCK_IMAGE_LINK_PICTURE_CLASSNAME}
              isInternalPicture
            />
          }
          intent={createDisplayOurProductsScreenIntent(category.urlKey)}
        >
          {category.name}
        </BlockImageLink>
      ))}
    </CSSSlider>
  )
}
